import React, { useState } from 'react';

// A grid of thumbnails the admin can drag into a new order. Arrow buttons do
// the same job for touch screens (which lack HTML drag and drop) and keyboards.
function SortableImageGrid({ images, onMove, onRemove, altPrefix = 'Image' }) {
  const [dragIndex, setDragIndex] = useState(null);
  const [overIndex, setOverIndex] = useState(null);

  const endDrag = () => {
    setDragIndex(null);
    setOverIndex(null);
  };

  const handleDrop = (index) => {
    if (dragIndex !== null && dragIndex !== index) onMove(dragIndex, index);
    endDrag();
  };

  const arrowClass = 'bg-black bg-opacity-60 text-white w-6 h-6 rounded-full text-xs hover:bg-opacity-80 disabled:opacity-30';

  return (
    <div className="grid grid-cols-3 gap-2">
      {images.map((src, index) => (
        <div
          key={`${index}-${src.slice(-24)}`}
          className="relative"
          draggable
          onDragStart={(e) => {
            setDragIndex(index);
            e.dataTransfer.effectAllowed = 'move';
          }}
          onDragOver={(e) => {
            e.preventDefault();
            if (overIndex !== index) setOverIndex(index);
          }}
          onDrop={(e) => {
            e.preventDefault();
            handleDrop(index);
          }}
          onDragEnd={endDrag}
          style={{
            cursor: 'grab',
            opacity: dragIndex === index ? 0.4 : 1,
            outline: overIndex === index && dragIndex !== index ? '3px solid #722f37' : 'none',
            borderRadius: '8px'
          }}
        >
          <img src={src} alt={`${altPrefix} ${index + 1}`} draggable={false} style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }} />
          <span className="absolute top-1 left-1 bg-black bg-opacity-60 text-white text-xs px-2 rounded-full">{index + 1}</span>
          {onRemove && (
            <button type="button" onClick={() => onRemove(index)} aria-label={`Remove ${altPrefix.toLowerCase()} ${index + 1}`} className="absolute top-1 right-1 bg-red-600 text-white w-6 h-6 rounded-full text-xs hover:bg-red-700"><span aria-hidden="true">✕</span></button>
          )}
          <div className="absolute bottom-1 left-1 right-1 flex justify-between">
            <button type="button" onClick={() => onMove(index, index - 1)} disabled={index === 0} aria-label={`Move ${altPrefix.toLowerCase()} ${index + 1} earlier`} className={arrowClass}><span aria-hidden="true">◀</span></button>
            <button type="button" onClick={() => onMove(index, index + 1)} disabled={index === images.length - 1} aria-label={`Move ${altPrefix.toLowerCase()} ${index + 1} later`} className={arrowClass}><span aria-hidden="true">▶</span></button>
          </div>
        </div>
      ))}
    </div>
  );
}

// Returns a copy of the list with one item moved from one position to another.
export function moveItem(list, from, to) {
  const copy = [...list];
  const [item] = copy.splice(from, 1);
  copy.splice(to, 0, item);
  return copy;
}

export default SortableImageGrid;
